var keyBenefitsSwiper;

      function initKeyBenefitSwiper() {
        keyBenefitsSwiper = new Swiper(".keyBenefitsSwiper", {
          slidesPerView: "auto",
          spaceBetween: 5,
          centeredSlides: false, // Default setting for screens wider than 672px
          loop: true,
          initialSlide: 0,

          breakpoints: {
            // Define settings for screens larger than 672px
            672: {
              centeredSlides: false, // Keep centeredSlides false for larger screens
              spaceBetween: 5,
            },
            // Default (below 672px)
            0: {
              centeredSlides: true, // Center slides on screens less than 672px
              spaceBetween: 10,
            },
          },
        });
      }

document.addEventListener("DOMContentLoaded", () => {
        initKeyBenefitSwiper();
});